import { useQuery } from 'react-query';

import getWebsiteSettings from 'api/settings/getWebsiteSettings';

import { QUERY_IDS } from 'api';
import useGetPathToNavigate from './useGetPathToNavigate';

const { GET_WEBSITE_SETTINGS } = QUERY_IDS;

const useGetWebsiteSettings = (lang) => {
  const { locale, isTranslationsEnabled } = useGetPathToNavigate();
  const language = lang || locale;
  const queryKey = isTranslationsEnabled ? [GET_WEBSITE_SETTINGS, language] : [GET_WEBSITE_SETTINGS];

  const { data, isFetching, isLoading, isSuccess, isError } = useQuery(
    queryKey,
    getWebsiteSettings
  );

  return {
    data,
    isFetching,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useGetWebsiteSettings;
